var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarSubMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "7px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -186 -176 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 1.3319836889513288  L 10.59000015258789 0  L 6 4.326585712027937  L 1.4099998474121094 0  L 0 1.3319836889513288  L 6 7  L 12 1.3319836889513288  Z ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none",
    fillOpacity: 0.8980392156862745,
    transform: "matrix(1 0 0 1 186 176 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarSubMenuIcon);
export default __webpack_public_path__ + "static/media/side_bar_sub_menu_icon.f75e9f0963c216a0f69d7812646bd7a1.svg";
export { ForwardRef as ReactComponent };